module.exports = __webpack_public_path__ + "img/mesa_el_i.7ca43af6.png";